import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { SectionImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/sectionImpression.trackingInfo";
import { getJsonPayload } from "@omni/utils/dom.utils";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: SectionImpressionTrackingInfo) => {
    const event: AnalyticsEvent<SectionImpressionTrackingInfo> = {
        event: EventType.SectionImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo);
};
